export const contactsRoutes = {
  'route.contacts.index': '/contacts',
  'api.contacts.send.message': 'contacts',
  'api.contacts.edit': 'clients/contact/[id]',
};
